module.exports = __webpack_public_path__ + "static/media/meter1.dea05c56.svg";